export function copyProps(dest: Object, src: Object) {
    for (const prop in src) {
        if (src.hasOwnProperty(prop)) {
            dest[prop] = src[prop];
        }
    }
}
